import { useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Card, Checkbox, Chip, Collapse, Fade, Grid, IconButton, Stack, Typography } from "@mui/material";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DESTINATION, LAYOUT_MARGIN, SOURCE } from "Configs/home";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import IRAN from "Assets/Images/iran.jpg";
import PLAQUE_FLAG from "Assets/Images/plaqueFlag.jpg";
import CallIcon from "@mui/icons-material/Call";
import { useDispatch } from "react-redux";
import { changeSelectedPassenger, changeShowSupportLeftSide, changeSupportRightSideMode } from "Redux/supportSideSlice";

import { passengerData } from "./passengerData";

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContentMargin: 16,
};

export default function Tickets() {
  const { visible: visibleInventory } = useAppSelector((state) => state.supportInventory);
  const dispatch = useDispatch();

  const { height } = useWindowSize();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const sideRef = useRef<HTMLDivElement>(null);

  const boxHeight = useMemo(() => {
    let result = 0;
    Object.keys(SIZES).forEach((key) => {
      result += SIZES[key];
    });
    return `${height - (result + LAYOUT_MARGIN * 2)}px`;
  }, [height]);

  const handleSelect = (id: number) => {
    dispatch(changeSelectedPassenger(id));
    dispatch(changeShowSupportLeftSide(true));
  };

  const handleBack = () => {
    dispatch(changeSupportRightSideMode(1));
    dispatch(changeShowSupportLeftSide(false));
  };

  return (
    <Fade in={visibleInventory} mountOnEnter unmountOnExit>
      <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight="800"> برنامه حرکت</Typography>

          <Button
            startIcon={<KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />}
            sx={{ minWidth: "100px" }}
            onClick={toggleCollapse}
          >
            {isOpen ? "بستن" : "بازکردن"}
          </Button>
        </Stack>

        <Collapse in={isOpen}>
          <Box sx={{ overflow: "scroll", height: boxHeight }}>
            <Stack
              sx={{
                mt: 1,
                p: 1,
                width: "97%",
                border: "1px solid #aaa",
                borderRadius: 1,
              }}
            >
              <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
                <Grid item md={8} sx={{ textAlign: "end" }} className="fa-number">
                  <Typography>یکشنبه ۲۰ اسفند</Typography>
                </Grid>
                <Grid container item md={4} sx={{ mb: "0px", mt: "5px", flexDirection: "row-reverse" }} className="fa-number">
                  <Button type="button" variant="contained" sx={{ minWidth: "45px" }} onClick={handleBack}>
                    <ArrowBackIcon />
                  </Button>
                </Grid>
              </Grid>
              <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "5px" }} spacing={2}>
                <Grid item md={2} textAlign="left" sx={{ mb: "10px" }} className="fa-number">
                  <Stack sx={{ alignItems: "center" }}>
                    <Typography color="common.black" sx={{ mb: "5px" }}>
                      14:30
                    </Typography>
                    <img src={SOURCE} alt="logo" style={{ width: "15px" }} />
                    <Typography color="common.black" sx={{ mt: "5px" }}>
                      مبدا
                    </Typography>
                  </Stack>
                </Grid>
                <Grid container item md={8} sx={{ mb: "10px", mt: "5px" }} className="fa-number">
                  <Grid item md={4} sx={{ textAlign: "center" }} className="fa-number">
                    <ArrowBackIosIcon />
                  </Grid>
                  <Grid item md={4} sx={{ textAlign: "center" }} className="fa-number">
                    <DirectionsBusIcon />
                  </Grid>
                  <Grid item md={4} sx={{ textAlign: "center" }} className="fa-number">
                    <ArrowBackIosIcon />
                  </Grid>
                </Grid>
                <Grid item md={2} textAlign="left" sx={{ mb: "10px" }} className="fa-number">
                  <Stack sx={{ alignItems: "center" }}>
                    <Typography color="common.black" sx={{ mb: "5px" }}>
                      15:20
                    </Typography>
                    <img src={DESTINATION} alt="logo" style={{ width: "15px" }} />
                    <Typography color="common.black" sx={{ mt: "5px" }}>
                      مقصد
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Stack>

            <Stack
              sx={{
                mt: 1,
                p: 1,
                width: "97%",
                border: "1px solid #aaa",
                borderRadius: 1,
              }}
            >
              <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
                <Grid item md={6} textAlign="left" className="fa-number">
                  <Typography> راننده : آرش مردانی </Typography>
                </Grid>
                <Grid container item md={4} sx={{ mb: "0px", mt: "5px" }} className="fa-number">
                  <Typography>09194981247</Typography>
                </Grid>
                <Grid container item md={2} sx={{ mb: "0px", mt: "5px" }} className="fa-number">
                  <Button type="button" variant="contained" sx={{ minWidth: "45px" }}>
                    <CallIcon />
                  </Button>
                </Grid>
              </Grid>
              <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "0px" }} spacing={2}>
                <Grid item md={4} textAlign="left" sx={{ mb: "10px" }} className="fa-number">
                  <Typography> خودرو :</Typography>
                  <Typography> ون زرد </Typography>
                </Grid>

                <Grid container item md={8} sx={{ mb: "10px", mt: "5px" }} className="fa-number">
                  <Grid container justifyContent="space-between" alignItems="strech">
                    <Grid
                      item
                      xs={2}
                      className="fa-number"
                      sx={{
                        display: "flex",
                        textAlign: "center",
                        flexDirection: "column",
                        border: "1px solid #979797",
                        borderRadius: "5px 0 0 5px",
                        padding: "5px 0",
                        alignItems: "center",
                      }}
                    >
                      <img src={IRAN} alt="flag" style={{ display: "inline-block", width: "20px", marginTop: "3px" }} />
                      <Typography>55</Typography>
                    </Grid>
                    <Grid
                      item
                      xs={8.4}
                      className="fa-number"
                      sx={{ border: "1px solid #979797", display: "flex", alignItems: "center" }}
                    >
                      <Grid
                        container
                        justifyContent="space-around"
                        alignItems="center"
                        sx={{ padding: "5px 0", boxSizing: "border-box", marginLeft: "10px" }}
                      >
                        <Grid item xs={3.5}>
                          <Typography>474</Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography>ت</Typography>
                        </Grid>
                        <Grid item xs={2.5}>
                          <Typography>44</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={1.6}
                      sx={{ border: "1px solid #979797", borderRadius: "0 5px 5px 0", display: "flex", alignItems: "center" }}
                    >
                      <img
                        src={PLAQUE_FLAG}
                        alt="flag"
                        style={{ display: "inline-block", height: "50px", width: "100%", borderRadius: "5px 0 0 5px" }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Stack>
            <Stack
              sx={{
                mt: 1,
                p: 1,
                width: "97%",
                border: "1px solid #aaa",
                borderRadius: 1,
              }}
            >
              <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "5px" }}>
                <Grid item md={6} textAlign="left" className="fa-number">
                  <Typography sx={{ mt: "5px" }} className="fa-number">
                    شرکت حمل :
                  </Typography>
                </Grid>
                <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                  <Typography sx={{ mt: "5px" }} className="fa-number">
                    شرکت حمل بهمراه
                  </Typography>
                </Grid>
              </Grid>
              <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: "5px" }}>
                <Grid item md={6} textAlign="left" className="fa-number">
                  <Typography sx={{ mt: "5px" }} className="fa-number">
                    شماره اپراتور :
                  </Typography>
                </Grid>
                <Grid container item md={6} sx={{ flexDirection: "row-reverse" }} className="fa-number">
                  <Typography sx={{ mt: "5px" }} className="fa-number">
                    09195241247
                  </Typography>
                </Grid>
              </Grid>
            </Stack>

            {passengerData.map((p, index) => (
              <Button
                type="button"
                sx={{
                  mt: 1,
                  p: 1,
                  width: "97%",
                  border: "1px solid #aaa",
                  borderRadius: 1,
                }}
                onClick={() => handleSelect(p.id)}
              >
                <Grid
                  container
                  justifyContent="space-around"
                  alignItems="center"
                  sx={{ padding: "5px 0", boxSizing: "border-box" }}
                  spacing={2}
                >
                  <Grid item xs={8} sx={{ textAlign: "start" }}>
                    <Typography className="fa-number">
                      {index + 1}.{p.name}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className="fa-number">{p.phoneNumber}</Typography>
                  </Grid>
                </Grid>
              </Button>
            ))}
          </Box>
        </Collapse>
      </Card>
    </Fade>
  );
}
